module.exports = __webpack_public_path__ + "img/logo-floripa.e399c48b.png";